// Use only the authorized stored first-name field, never a display-name guess.
export function rosterPlayerLabel(player) {
  const username = typeof player?.username === 'string' ? player.username.trim() : '';
  if (!username) return 'Player';
  const first = typeof player.first_name === 'string' ? player.first_name.trim() : '';
  const safeFirst = first && first.length <= 50 && /^[\p{L} .'-]+$/u.test(first);
  return safeFirst ? `${username} (${first})` : username;
}
